import { render, staticRenderFns } from "./bardd.vue?vue&type=template&id=77a7e9f8&scoped=true"
import script from "./bardd.vue?vue&type=script&lang=js"
export * from "./bardd.vue?vue&type=script&lang=js"
import style0 from "./bardd.vue?vue&type=style&index=0&id=77a7e9f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a7e9f8",
  null
  
)

export default component.exports